/**
* @author Camilo
* @since  18/12/2017
**/
export class PerfilModel{

	constructor(public nidrol:number, public cdescriprol:string){}

}




// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/AdministracionUsuarios/Perfil.model.ts